import { render, staticRenderFns } from "./Dealers.create.vue?vue&type=template&id=15cc9517&"
import script from "./Dealers.create.vue?vue&type=script&lang=js&"
export * from "./Dealers.create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports